import React from 'react';
import cn from 'classnames';

interface DocumentationRequirementBulletItemProps {
  label: React.ReactNode;
  description: React.ReactNode;
  note?: React.ReactNode;
  viewSampleText?: React.ReactNode;
  onViewSampleClick?: () => void;
}

const DocumentationRequirementBulletItem = ({
  label,
  description,
  note,
  viewSampleText,
  onViewSampleClick,
}: DocumentationRequirementBulletItemProps) => {
  const normalizedLabel = typeof label === 'string' ? label.replace(/:$/, '') : label;

  return (
    <div className={cn('self-stretch pl-2 relative')}>
      <div className={cn('w-1.5 h-6 left-0 top-0 absolute')}>
        <div className={cn('left-0 top-[-2px] absolute justify-start text-blue text-base font-normal leading-6')}>•</div>
      </div>
      <div className={cn('flex flex-col gap-2')}>
        <div className={cn('justify-start text-left')}>
          <span className={cn('text-brand-navy inline-block text-base font-bold leading-6')}>
            {normalizedLabel}
            {':'}
          </span>
          <span className={cn('text-gray-800 text-base font-normal leading-6 pl-0.5')}> {description}</span>
          {viewSampleText ? (
            onViewSampleClick ? (
              <button
                type='button'
                onClick={onViewSampleClick}
                className={cn(
                  'ml-2 bg-transparent border-0 p-0 text-blue inline-block text-sm font-medium underline leading-5 w-fit whitespace-nowrap cursor-pointer'
                )}
              >
                {viewSampleText}
              </button>
            ) : (
              <span className={cn('pl-2 text-blue inline-block text-sm font-medium underline leading-5 w-fit whitespace-nowrap')}>
                {viewSampleText}
              </span>
            )
          ) : null}
          {note ? <span className={cn('block text-sm font-normal text-blue')}>{note}</span> : null}
        </div>
      </div>
    </div>
  );
};

export default DocumentationRequirementBulletItem;
